import { manifest } from '../content/manifest';

/** Manifest — editorial serif reading column, tracked Cinzel eyebrow + title. Static content (SC-006). */
export default function Manifest() {
  return (
    <article className="mx-auto w-full max-w-prose px-6 py-16 sm:py-20">
      <p className="font-display text-xs font-semibold uppercase tracking-[0.28em] text-accent-deep">
        {manifest.eyebrow}
      </p>
      <h1 className="mt-3 font-display text-3xl font-semibold uppercase tracking-[0.12em] text-ink sm:text-4xl">
        {manifest.title}
      </h1>
      <p className="mt-4 font-serif text-xl italic text-muted">{manifest.lede}</p>
      <hr className="my-10 border-border" />

      {manifest.sections.map((section) => (
        <section key={section.heading} className="mb-10">
          <h2 className="font-display text-lg font-semibold uppercase tracking-[0.12em] text-ink">
            {section.heading}
          </h2>
          {'paragraphs' in section &&
            section.paragraphs?.map((p, i) => (
              <p key={i} className="mt-4 font-serif text-lg leading-relaxed text-ink">
                {p}
              </p>
            ))}
          {'items' in section && section.items && (
            <ul className="mt-4 space-y-3">
              {section.items.map(([term, def]) => (
                <li key={term} className="font-serif text-lg leading-relaxed text-ink">
                  <strong className="font-sans text-sm font-semibold uppercase tracking-wide text-accent-deep">
                    {term}
                  </strong>
                  <span className="mt-1 block">{def}</span>
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <section className="rounded-lg border border-border bg-surface p-6">
        <h2 className="font-display text-lg font-semibold uppercase tracking-[0.12em] text-ink">
          {manifest.invitation.heading}
        </h2>
        {manifest.invitation.paragraphs.map((p, i) => (
          <p key={i} className="mt-4 font-serif text-lg leading-relaxed text-ink">
            {p}
          </p>
        ))}
        <p className="mt-4 font-serif text-lg italic text-accent-deep">{manifest.invitation.motto}</p>
      </section>

      <p className="mt-10 font-sans text-xs text-muted">{manifest.disclaimer}</p>
    </article>
  );
}
